"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _alertDialog = require("@design/ui/alert-dialog");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var ActiveUsersWarningDialog = function ActiveUsersWarningDialog(_ref) {
  var open = _ref.open,
    onOpenChange = _ref.onOpenChange,
    participants = _ref.participants,
    onProceed = _ref.onProceed;
  var participantList = participants.map(function (participant, index) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
      children: [index + 1, ". ", participant.name, participant.role ? " (".concat(participant.role, ")") : ""]
    }, "".concat(participant.name, "-").concat(index));
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_alertDialog.AlertDialog, {
    open: open,
    onOpenChange: onOpenChange,
    "data-sentry-element": "AlertDialog",
    "data-sentry-component": "ActiveUsersWarningDialog",
    "data-sentry-source-file": "ActiveUsersWarningDialog.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_alertDialog.AlertDialogContent, {
      "data-sentry-element": "AlertDialogContent",
      "data-sentry-source-file": "ActiveUsersWarningDialog.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_alertDialog.AlertDialogHeader, {
        "data-sentry-element": "AlertDialogHeader",
        "data-sentry-source-file": "ActiveUsersWarningDialog.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_alertDialog.AlertDialogMedia, {
          "data-sentry-element": "AlertDialogMedia",
          "data-sentry-source-file": "ActiveUsersWarningDialog.tsx",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ErrorIcon, {
            className: "text-brand-yellow",
            "data-sentry-element": "ErrorIcon",
            "data-sentry-source-file": "ActiveUsersWarningDialog.tsx"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_alertDialog.AlertDialogTitle, {
          "data-sentry-element": "AlertDialogTitle",
          "data-sentry-source-file": "ActiveUsersWarningDialog.tsx",
          children: "Save new version"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_alertDialog.AlertDialogDescription, {
          "data-sentry-element": "AlertDialogDescription",
          "data-sentry-source-file": "ActiveUsersWarningDialog.tsx",
          children: "Saving this document as a new version will end the current editing session for these active members:"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ol", {
        className: "flex flex-col gap-1 text-sm",
        children: participantList
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: "text-sm text-muted-foreground",
        children: "Do you want to proceed?"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_alertDialog.AlertDialogFooter, {
        "data-sentry-element": "AlertDialogFooter",
        "data-sentry-source-file": "ActiveUsersWarningDialog.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_alertDialog.AlertDialogCancel, {
          "data-sentry-element": "AlertDialogCancel",
          "data-sentry-source-file": "ActiveUsersWarningDialog.tsx",
          children: "Cancel"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_alertDialog.AlertDialogAction, {
          onClick: onProceed,
          "data-sentry-element": "AlertDialogAction",
          "data-sentry-source-file": "ActiveUsersWarningDialog.tsx",
          children: "Proceed"
        })]
      })]
    })
  });
};
var _default = exports.default = ActiveUsersWarningDialog;